import { SxProps } from "@mui/material";

export const sxError: SxProps = {
  color: '#D84141',
  fontSize: '12px'
}

export const sxButton: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
  maxWidth: '300px',
  '@media (max-width: 768px)': {
    maxWidth: '340px',
    width: 'stretch'
  }
}

export const sxContactButton: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
  border: '2px solid #00995D',
  color: 'rgb(0,0,0,0.08)',
  '&:focus': {
    background: '#fff'
  }
}

export const sxTextButton: SxProps = {
  border: "none",
  background: "transparent",
  color: "var(--Primary-01-Medium, #00995D)",
  textAlign: "center",
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  "&:hover": { background: 'unset' },
  '@media (max-width: 768px)': {
    height: '40px'
  }
}

export const sxCircularLoadingProgress: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  marginTop: '100px'
}

export const sxSelect: SxProps = {
  fontFamily: 'Unimed-Sans',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '400',
  svg: {color: '#383838'},
  maxWidth: '400px',
  '@media (max-width: 450px)': {
    width: '320px'
  },
  '@media (max-width: 330px)': {
    width: '280px'
  },
}